import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBriefcase = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3332 17.5V4.16667C13.3332 3.72464 13.1576 3.30072 12.845 2.98816C12.5325 2.67559 12.1085 2.5 11.6665 2.5H8.33317C7.89114 2.5 7.46722 2.67559 7.15466 2.98816C6.8421 3.30072 6.6665 3.72464 6.6665 4.16667V17.5M3.33317 5.83333H16.6665C17.587 5.83333 18.3332 6.57953 18.3332 7.5V15.8333C18.3332 16.7538 17.587 17.5 16.6665 17.5H3.33317C2.4127 17.5 1.6665 16.7538 1.6665 15.8333V7.5C1.6665 6.57953 2.4127 5.83333 3.33317 5.83333Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBriefcase;
